import { useLayoutEffect, useRef, useState } from "react";

export const usePreviewOverflow = (enabled) => {
  const contentRef = useRef(null);
  const [overflows, setOverflows] = useState(false);

  useLayoutEffect(() => {
    const content = contentRef.current;
    if (!enabled || !content) return undefined;
    const measure = () => {
      const limit = parseFloat(getComputedStyle(content.parentElement)
        .getPropertyValue("--guide-preview-height"));
      setOverflows(Number.isFinite(limit) && content.getBoundingClientRect().height > limit + 1);
    };
    measure();
    // Observe the natural content, not the clamped container: expanding the
    // preview must not hide its toggle. This also covers image loads and edits.
    const observer = typeof ResizeObserver === "function" ? new ResizeObserver(measure) : null;
    observer?.observe(content);
    window.addEventListener("resize", measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [enabled]);

  return { contentRef, overflows };
};
